export default __webpack_public_path__ + "static/media/08.7ba84a38.png";